/**
 * External Imports
 */
import { FC, useCallback } from 'react';
import { connect } from 'react-redux';

/**
 * Internal Imports
 */
import SupportListSettingsTable from './supportListSettingsTable/SupportListSettingsTable';
import { RootState } from '../../../../redux/store';
import {
  useGetEmployeeSubjectConfigQuery,
  useUpdateSubjectHiddenStatusMutation
} from '../../../../redux/apis/Users.api';

import { useFeatures } from '../../../../services/Features/features';
import { useUserRolesRef } from '../../../../services/UserRoles';

/**
 * GLobal Type Definition Imports
 */
import { ValidationEmployee } from '../../../../config/interfaces';

interface SafetyListSettingsProps {
  facilityId: string;
  userId: string;
}

const SafetyListSettingsTable: FC<SafetyListSettingsProps> = ({
  facilityId,
  userId
}) => {
  const {
    isEnterpriseAdmin,
    isNonSupportRounder,
    isTemplateConfigurator,
    isUserAdmin,
    isSafetyValidationRounder
  } = useUserRolesRef();

  const { isSafetyValidationEnabled } = useFeatures();

  const {
    data: safetyValidationEmployeeData,
    // isError: isGetEmployeeSubjectConfigError,
    // isFetching: isGetEmployeeSubjectConfigFetching,
    isLoading: isGetEmployeeSubjectConfigLoading
  } = useGetEmployeeSubjectConfigQuery(
    // Need to adjust later when we know new validation rounding types
    { employeeId: userId, roundingType: 'safetyValidation' },
    {
      refetchOnMountOrArgChange: 15,
      skip: !isSafetyValidationEnabled || !userId
    }
  );
  const [
    updateSubjectHiddenStatus
    // {
    //   isError: isUpdateSubjectHiddenStatusError,
    //   isLoading: isUpdateSubjectHiddenStatusLoading,
    //   isSuccess: isUpdateSubjectHiddenStatusSuccess
    // }
  ] = useUpdateSubjectHiddenStatusMutation();

  const hideEmployee = useCallback(
    (employee: ValidationEmployee) => {
      updateSubjectHiddenStatus({
        employeeId: employee.hcaid,
        facilityId,
        roundingType: 'safetyValidation',
        userId,
        visible: !employee.visible
      });
    },
    [facilityId, userId]
  );

  return (
    <SupportListSettingsTable
      employees={safetyValidationEmployeeData}
      isFacilitySelectorEnabled={
        isEnterpriseAdmin ||
        (isSafetyValidationRounder &&
          !(isNonSupportRounder || isTemplateConfigurator || isUserAdmin))
      }
      isTableEnabled={isSafetyValidationEnabled}
      loadingSupportList={isGetEmployeeSubjectConfigLoading}
      type="safety"
      hideEmployee={hideEmployee}
    />
  );
};

const mapReduxStateToProps = (state: RootState) => {
  return {
    facilityId: state.AuthorizedUser.authorizedUser.facilityId,
    userId: state.AuthorizedUser.authorizedUser.hcaid
  };
};

export default connect(mapReduxStateToProps)(SafetyListSettingsTable);
